// extracted by mini-css-extract-plugin
export default {"content":"ProjectAirYardPage_content__HwKdJ"};